export type FacebookProfile = {
  email: string;
  firstName: string;
  lastName: string;
};

export const getFacebookProfile = (): Promise<FacebookProfile> =>
  new Promise((resolve, reject) => {
    if (!window.FB) return reject('Facebook SDK is not loaded.');

    window.FB.api('me', 'get', { fields: ['first_name', 'last_name', 'email'] }, response =>
      response.email
        ? Promise.resolve({
            email: response.email,
            firstName: response.first_name,
            lastName: response.last_name
          })
        : reject('Failed to get Facebook profile.')
    );
  });
